(function () {
  'use strict';

  // Nav label: Fly Packs → Fly Kits (works even if Liquid page cache is stale)
  function ffsRenameFlyPacksNav() {
    document.querySelectorAll('a.header__menu-item span, a.menu-drawer__menu-item').forEach(function (el) {
      if ((el.textContent || '').trim() === 'Fly Packs') el.textContent = 'Fly Kits';
    });
  }
  ffsRenameFlyPacksNav();
  document.addEventListener('DOMContentLoaded', ffsRenameFlyPacksNav);

  // Build Your Box hero: swap to latest demo if present (CDN-bust new filename)
  function ffsUpgradeBoxHeroVideo() {
    var root = document.querySelector('[data-ffs-box-hero-video]');
    if (!root) return;
    var video = root.querySelector('video');
    var source = root.querySelector('source');
    if (!video || !source) return;
    var src = source.getAttribute('src') || '';
    if (src.indexOf('ffs-box-builder-hero-v14.mp4') !== -1) return;
    var next = src
      .replace(/ffs-box-builder-hero-v11\.mp4/, 'ffs-box-builder-hero-v14.mp4')
      .replace(/ffs-box-builder-hero-v10\.mp4/, 'ffs-box-builder-hero-v14.mp4')
      .replace(/ffs-box-builder-hero-v9\.mp4/, 'ffs-box-builder-hero-v14.mp4')
      .replace(/ffs-box-builder-hero-v8\.mp4/, 'ffs-box-builder-hero-v14.mp4')
      .replace(/ffs-box-builder-hero-v7\.mp4/, 'ffs-box-builder-hero-v14.mp4')
      .replace(/ffs-box-builder-hero\.mp4/, 'ffs-box-builder-hero-v14.mp4');
    if (next === src) {
      next = '/cdn/shop/t/20/assets/ffs-box-builder-hero-v14.mp4';
    }
    source.setAttribute('src', next);
    var poster = video.getAttribute('poster') || '';
    if (poster) {
      video.setAttribute(
        'poster',
        poster
          .replace(/ffs-box-builder-hero-v11-poster\.jpg/, 'ffs-box-builder-hero-v14-poster.jpg')
          .replace(/ffs-box-builder-hero-v10-poster\.jpg/, 'ffs-box-builder-hero-v14-poster.jpg')
          .replace(/ffs-box-builder-hero-v9-poster\.jpg/, 'ffs-box-builder-hero-v14-poster.jpg')
          .replace(/ffs-box-builder-hero-v8-poster\.jpg/, 'ffs-box-builder-hero-v14-poster.jpg')
          .replace(/ffs-box-builder-hero-v7-poster\.jpg/, 'ffs-box-builder-hero-v14-poster.jpg')
          .replace(/ffs-box-builder-hero-poster\.jpg/, 'ffs-box-builder-hero-v14-poster.jpg')
      );
    }
    video.load();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
  }
  ffsUpgradeBoxHeroVideo();
  document.addEventListener('DOMContentLoaded', ffsUpgradeBoxHeroVideo);

  // Always open a real mailto for catch submissions (works even if an old href is cached)
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest('.ffs-report__submit-link, .ffs-catch-email__btn');
      if (!link) return;
      var mail = 'mailto:support@floatingfeathersupplyco.com?subject=Fish%20of%20the%20Week%20-%20catch%20photo';
      if (link.getAttribute('href') !== mail) {
        event.preventDefault();
        window.location.href = mail;
      }
    },
    true
  );

  const DATA = window.FFS_FISHING_REPORT;
  if (!DATA) return;

  const USGS_IV = 'https://waterservices.usgs.gov/nwis/iv/?format=json&siteStatus=all&parameterCd=00060,00010';

  const cToF = (c) => Math.round((parseFloat(c) * 9) / 5 + 32);

  const fmtFlow = (cfs) => {
    const n = parseFloat(cfs);
    if (Number.isNaN(n)) return '—';
    return n >= 1000 ? `${Math.round(n).toLocaleString()} cfs` : `${Math.round(n)} cfs`;
  };

  const fmtTemp = (c) => {
    const n = parseFloat(c);
    if (Number.isNaN(n)) return '—';
    return `${cToF(n)}°F`;
  };

  const flowStatus = (cfs) => {
    const n = parseFloat(cfs);
    if (Number.isNaN(n)) return { label: 'No data', tone: 'muted' };
    if (n < 150) return { label: 'Low', tone: 'low' };
    if (n < 800) return { label: 'Ideal', tone: 'good' };
    if (n < 2500) return { label: 'Moderate', tone: 'moderate' };
    return { label: 'High', tone: 'high' };
  };

  const tempStatus = (c) => {
    const f = cToF(c);
    if (Number.isNaN(f)) return { label: '—', tone: 'muted' };
    if (f < 45) return { label: 'Cold', tone: 'cold' };
    if (f <= 65) return { label: 'Prime', tone: 'good' };
    if (f <= 68) return { label: 'Warm', tone: 'moderate' };
    return { label: 'Caution', tone: 'high' };
  };

  class FfsFishingReport extends HTMLElement {
    connectedCallback() {
      this.root = this;
      this.activeRegion = (DATA.regions[0] && DATA.regions[0].id) || 'northern_rockies';
      this.activeRiverId = null;
      this.hatchRegion = this.activeRegion;
      this.boxRegion = this.activeRegion;
      this.boxElevation = 'mid';
      this.boxWaterType = 'river';
      this.gaugeData = {};
      this.boxQty = {};
      this.boxDefaultQty = 2;
      this.boxMaxQty = 12;
      this.applyUrlPreselect();
      this.init();
    }

    /* ?region=&elevation=&water= deep links (report river cards → builder page) */
    applyUrlPreselect() {
      const params = new URLSearchParams(window.location.search);
      let region = params.get('region');
      /* Legacy single East bucket → Northeast */
      if (region === 'east') region = 'northeast';
      const elevation = params.get('elevation');
      const water = params.get('water');
      if (region && DATA.regions.some((r) => r.id === region)) {
        this.boxRegion = region;
        this.activeRegion = region;
        this.hatchRegion = region;
      }
      if (elevation && (DATA.boxElevations || []).some((e) => e.id === elevation)) {
        this.boxElevation = elevation;
      }
      if (water && (DATA.boxWaterTypes || []).some((w) => w.id === water)) {
        this.boxWaterType = water;
      }
    }

    syncHatchToBox() {
      if (!this.hasAttribute('data-sync-hatch')) return;
      this.hatchRegion = this.boxRegion;
      this.renderHatchTabs();
      this.bindHatchTabs();
      this.renderRegionalHatch();
    }

    init() {
      this.resetBoxSelection();
      this.ensureActiveRiver();
      this.renderRiverPickers();
      this.renderHatchTabs();
      this.renderRivers();
      this.renderStaticSections();
      this.renderBestFlies();
      this.bindHatchTabs();
      this.fetchGauges();
      this.updateTimestamp();
    }

    $(sel) {
      return this.root.querySelector(sel);
    }

    $$(sel) {
      return this.root.querySelectorAll(sel);
    }

    riversInRegion(regionId) {
      return DATA.rivers.filter((r) => r.region === regionId);
    }

    ensureActiveRiver() {
      const rivers = this.riversInRegion(this.activeRegion);
      if (!rivers.length) {
        this.activeRiverId = null;
        return;
      }
      if (!rivers.some((r) => r.siteId === this.activeRiverId)) {
        this.activeRiverId = rivers[0].siteId;
      }
    }

    renderRiverPickers() {
      const wrap = this.$('[data-ffs-report-pickers]');
      if (!wrap) return;
      const rivers = this.riversInRegion(this.activeRegion);
      const regionOptions = DATA.regions
        .map((r) => {
          const selected = r.id === this.activeRegion ? ' selected' : '';
          return `<option value="${r.id}"${selected}>${r.label}</option>`;
        })
        .join('');
      const riverOptions = rivers
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name) || a.section.localeCompare(b.section))
        .map((r) => {
          const selected = r.siteId === this.activeRiverId ? ' selected' : '';
          return `<option value="${r.siteId}"${selected}>${r.name}</option>`;
        })
        .join('');

      wrap.innerHTML = `
        <div class="ffs-report__picker">
          <label class="ffs-report__picker-label" for="ffs-report-region">Region</label>
          <select class="ffs-report__select" id="ffs-report-region" data-ffs-region-select>
            ${regionOptions}
          </select>
        </div>
        <div class="ffs-report__picker">
          <label class="ffs-report__picker-label" for="ffs-report-river">Water</label>
          <select class="ffs-report__select" id="ffs-report-river" data-ffs-river-select size="1">
            ${riverOptions}
          </select>
        </div>
      `;

      wrap.querySelector('[data-ffs-region-select]')?.addEventListener('change', (event) => {
        this.activeRegion = event.target.value;
        this.hatchRegion = this.activeRegion;
        this.ensureActiveRiver();
        this.renderRiverPickers();
        this.renderRivers();
        this.renderHatchTabs();
        this.renderRegionalHatch();
      });

      wrap.querySelector('[data-ffs-river-select]')?.addEventListener('change', (event) => {
        this.activeRiverId = event.target.value;
        this.renderRivers();
      });
    }

    renderRivers() {
      const grid = this.$('[data-ffs-report-rivers]');
      if (!grid) return;
      this.ensureActiveRiver();
      const river = DATA.rivers.find((r) => r.siteId === this.activeRiverId);
      grid.innerHTML = river ? this.riverCardHtml(river) : '<p class="ffs-report__empty">No rivers in this region yet.</p>';
    }

    renderHatchTabs() {
      const wrap = this.$('[data-ffs-hatch-tabs]');
      if (!wrap) return;
      const regionOptions = DATA.regions
        .map((r) => {
          const selected = r.id === this.hatchRegion ? ' selected' : '';
          return `<option value="${r.id}"${selected}>${r.label}</option>`;
        })
        .join('');

      wrap.innerHTML = `
        <div class="ffs-report__picker ffs-report__picker--hatch">
          <label class="ffs-report__picker-label" for="ffs-hatch-region">Location</label>
          <select class="ffs-report__select" id="ffs-hatch-region" data-ffs-hatch-region>
            ${regionOptions}
          </select>
        </div>
      `;

      wrap.querySelector('[data-ffs-hatch-region]')?.addEventListener('change', (event) => {
        this.hatchRegion = event.target.value;
        this.activeRegion = this.hatchRegion;
        this.ensureActiveRiver();
        this.renderRegionalHatch();
        this.renderRiverPickers();
        this.renderRivers();
      });
    }

    bindHatchTabs() {
      /* Hatch location select is bound inside renderHatchTabs() */
    }

    hatchHref(label) {
      const map = DATA.hatchLinks || {};
      return map[label] || '/collections/all-flies';
    }

    shopPatternsHref(river) {
      const flies = river.flies || [];
      const product = flies.find((url) => typeof url === 'string' && url.indexOf('/products/') === 0);
      if (product) return product;
      const collection = flies.find((url) => typeof url === 'string' && url.indexOf('/collections/') === 0);
      if (collection) return collection;
      if (river.hatches && river.hatches.length) return this.hatchHref(river.hatches[0]);
      return '/collections/all-flies';
    }

    builderHref(river) {
      const type = String(river.type || '').toLowerCase();
      let water = 'river';
      if (type.indexOf('tailwater') !== -1) water = 'tailwater';
      else if (type.indexOf('creek') !== -1 || type.indexOf('limestone') !== -1) water = 'creek';
      else if (type.indexOf('still') !== -1 || type.indexOf('lake') !== -1) water = 'stillwater';
      const ft = parseInt(String(river.elevation || '').replace(/[^0-9]/g, ''), 10);
      let elevation = 'mid';
      if (ft && ft < 4000) elevation = 'low';
      else if (ft && ft > 8000) elevation = 'high';
      return `/pages/build-your-box?region=${river.region}&elevation=${elevation}&water=${water}`;
    }

    riverCardHtml(river) {
      const g = this.gaugeData[river.siteId] || {};
      const hasFlow = g.flow != null;
      const hasTemp = g.temp != null;
      const flow = hasFlow ? fmtFlow(g.flow) : '—';
      const temp = hasTemp ? fmtTemp(g.temp) : hasFlow ? 'N/A' : '—';
      const fStat = hasFlow ? flowStatus(g.flow) : { label: 'Updating', tone: 'muted' };
      const tStat = hasTemp ? tempStatus(g.temp) : { label: hasFlow ? 'Unavailable' : 'Updating', tone: 'muted' };
      const hatchTags = river.hatches
        .map((h) => {
          const href = this.hatchHref(h);
          return `<a class="ffs-report__tag" href="${href}">${h}</a>`;
        })
        .join('');
      const shopHref = this.shopPatternsHref(river);

      return `
        <article class="ffs-report__river-card" data-site="${river.siteId}">
          <header class="ffs-report__river-head">
            <div>
              <h3 class="ffs-report__river-name">${river.name}</h3>
              <p class="ffs-report__river-section">${river.section} · ${river.elevation} · ${river.type}</p>
            </div>
          </header>
          <div class="ffs-report__metrics">
            <div class="ffs-report__metric">
              <span class="ffs-report__metric-label">Flow</span>
              <strong class="ffs-report__metric-value" data-flow="${river.siteId}">${flow}</strong>
              <span class="ffs-report__metric-status ffs-report__metric-status--${fStat.tone}">${fStat.label}</span>
            </div>
            <div class="ffs-report__metric">
              <span class="ffs-report__metric-label">Temp</span>
              <strong class="ffs-report__metric-value" data-temp="${river.siteId}">${temp}</strong>
              <span class="ffs-report__metric-status ffs-report__metric-status--${tStat.tone}">${tStat.label}</span>
            </div>
          </div>
          <p class="ffs-report__river-notes">${river.notes}</p>
          <div class="ffs-report__tags">${hatchTags}</div>
          <div class="ffs-report__river-ctas">
            <a class="ffs-report__build-link" href="${this.builderHref(river)}">Build a box for this water</a>
            <a class="ffs-report__fly-link" href="${shopHref}">Shop patterns →</a>
          </div>
        </article>
      `;
    }

    renderStaticSections() {
      this.renderRegionalHatch();
      this.renderSources();
    }

    hatchTextLink(text) {
      const map = DATA.hatchLinks || {};
      // Prefer exact map keys found inside the label (longest first)
      const keys = Object.keys(map).sort((a, b) => b.length - a.length);
      for (const key of keys) {
        if (text === key || text.indexOf(key) !== -1) {
          return `<a class="ffs-report__hatch-link" href="${map[key]}">${text}</a>`;
        }
      }
      return text;
    }

    renderRegionalHatch() {
      const el = this.$('[data-ffs-report-hatch]');
      const hatch = DATA.regionalHatches[this.hatchRegion];
      if (!el || !hatch) return;
      const list = (label, items) =>
        items.length
          ? `<div class="ffs-report__hatch-col"><h4>${label}</h4><ul>${items
              .map((i) => `<li>${this.hatchTextLink(i)}</li>`)
              .join('')}</ul></div>`
          : '';
      el.innerHTML = `
        <div class="ffs-report__hatch-board">
          <p class="ffs-report__hatch-kicker">${hatch.title}</p>
          <div class="ffs-report__hatch-grid">
            ${list('Active now', hatch.active)}
            ${list('Emerging', hatch.emerging)}
            ${list('Winding down', hatch.winding)}
          </div>
          <p class="ffs-report__hatch-note">${hatch.note}</p>
        </div>
      `;
    }

    money(n) {
      return `$${Number(n).toFixed(2)}`;
    }

    regionMeta(id) {
      return (DATA.regions || []).find((r) => r.id === id) || { id, label: id, blurb: '' };
    }

    regionLabel(id) {
      return this.regionMeta(id).label || id;
    }

    elevationMeta(id) {
      return (DATA.boxElevations || []).find((e) => e.id === id) || { id, label: id, short: '' };
    }

    waterTypeMeta(id) {
      return (DATA.boxWaterTypes || []).find((w) => w.id === id) || { id, label: id, short: '' };
    }

    flyKind(fly) {
      const kind = (fly && fly.kind) || 'dry';
      if (kind === 'terrestrial' || kind === 'nymph') return kind;
      return 'dry';
    }

    flyDotStyle(kind) {
      if (kind === 'terrestrial') return ' style="background:#74b3e3"';
      return '';
    }

    flyKindLabel(kind) {
      if (kind === 'terrestrial') return 'Terrestrial';
      if (kind === 'nymph') return 'Nymph';
      return 'Dry';
    }

    flyKindOrder(kind) {
      if (kind === 'nymph') return 0;
      if (kind === 'dry') return 1;
      if (kind === 'terrestrial') return 2;
      return 3;
    }

    currentBoxFlies() {
      const key = `${this.boxRegion}|${this.boxElevation}|${this.boxWaterType}`;
      const fallback = 'northern_rockies|mid|river';
      const handles = (DATA.boxSets && DATA.boxSets[key]) || (DATA.boxSets && DATA.boxSets[fallback]) || [];
      const catalog = DATA.flyCatalog || {};
      return handles
        .map((handle) => catalog[handle])
        .filter(Boolean)
        .slice()
        .sort((a, b) => {
          const byKind = this.flyKindOrder(this.flyKind(a)) - this.flyKindOrder(this.flyKind(b));
          if (byKind !== 0) return byKind;
          return String(a.title || '').localeCompare(String(b.title || ''));
        });
    }

    flyQty(handle) {
      const n = Number(this.boxQty[handle] || 0);
      return Number.isFinite(n) && n > 0 ? n : 0;
    }

    setFlyQty(handle, qty) {
      const next = Math.max(0, Math.min(this.boxMaxQty, Math.round(Number(qty) || 0)));
      if (next <= 0) delete this.boxQty[handle];
      else this.boxQty[handle] = next;
    }

    clampBulkQty(qty) {
      const next = Math.round(Number(qty) || 0);
      return Math.max(1, Math.min(this.boxMaxQty, next));
    }

    applyBulkQty(qty = this.boxDefaultQty) {
      this.boxDefaultQty = this.clampBulkQty(qty);
      this.resetBoxSelection(this.boxDefaultQty);
    }

    resetBoxSelection(qty = this.boxDefaultQty) {
      this.boxQty = {};
      this.currentBoxFlies().forEach((f) => {
        this.boxQty[f.handle] = qty;
      });
    }

    clearBoxSelection() {
      this.boxQty = {};
    }

    selectedFlyList() {
      return this.currentBoxFlies()
        .map((f) => ({ ...f, qty: this.flyQty(f.handle) }))
        .filter((f) => f.qty > 0);
    }

    boxTotals() {
      const selected = this.selectedFlyList();
      const patterns = selected.length;
      const count = selected.reduce((sum, f) => sum + f.qty, 0);
      const total = selected.reduce((sum, f) => sum + Number(f.price || 0) * f.qty, 0);
      return { count, patterns, total, available: this.currentBoxFlies().length };
    }

    renderBestFlies() {
      const el = this.$('[data-ffs-report-best-flies]');
      if (!el || !DATA.flyCatalog) return;

      const flies = this.currentBoxFlies();
      const { count, patterns, total, available } = this.boxTotals();

      const regionOptions = DATA.regions
        .map((r) => {
          const selected = r.id === this.boxRegion ? ' selected' : '';
          return `<option value="${r.id}"${selected}>${r.label}</option>`;
        })
        .join('');

      const elevOptions = (DATA.boxElevations || [])
        .map((e) => {
          const selected = e.id === this.boxElevation ? ' selected' : '';
          const short = e.short ? ` — ${e.short}` : '';
          return `<option value="${e.id}"${selected}>${e.label}${short}</option>`;
        })
        .join('');

      const waterOptions = (DATA.boxWaterTypes || [])
        .map((w) => {
          const selected = w.id === this.boxWaterType ? ' selected' : '';
          const short = w.short ? ` — ${w.short}` : '';
          return `<option value="${w.id}"${selected}>${w.label}${short}</option>`;
        })
        .join('');

      const flyCard = (fly) => {
        const qty = this.flyQty(fly.handle);
        const on = qty > 0;
        const kind = this.flyKind(fly);
        const productUrl = `/products/${fly.handle}`;
        return `
          <article class="ffs-box__fly${on ? ' is-selected' : ''}" data-fly-row="${fly.handle}">
            <a class="ffs-box__fly-media" href="${productUrl}">
              <img src="${fly.image}" alt="${fly.title}" width="120" height="120" loading="lazy">
            </a>
            <div class="ffs-box__fly-copy">
              <a class="ffs-box__fly-title" href="${productUrl}">
                <span class="ffs-box__dot ffs-box__dot--${kind}"${this.flyDotStyle(kind)} aria-hidden="true"></span>
                ${fly.title}
              </a>
              <span>${fly.why}</span>
            </div>
            <div class="ffs-box__fly-controls">
              <span class="ffs-box__fly-price">${this.money(fly.price)}</span>
              <div class="ffs-box__qty" role="group" aria-label="Quantity for ${fly.title}">
                <button type="button" class="ffs-box__qty-btn" data-qty-delta="-1" data-fly-handle="${fly.handle}" aria-label="Remove one ${fly.title}">−</button>
                <span class="ffs-box__qty-val" data-qty-val>${qty}</span>
                <button type="button" class="ffs-box__qty-btn" data-qty-delta="1" data-fly-handle="${fly.handle}" aria-label="Add one ${fly.title}">+</button>
              </div>
            </div>
          </article>
        `;
      };

      const kindGroups = [
        { id: 'nymph', label: 'Nymphs' },
        { id: 'dry', label: 'Dries' },
        { id: 'terrestrial', label: 'Terrestrials' },
      ]
        .map((group) => {
          const groupFlies = flies.filter((f) => this.flyKind(f) === group.id);
          if (!groupFlies.length) return '';
          return `
            <section class="ffs-box__group" data-fly-kind="${group.id}">
              <h3 class="ffs-box__group-title">
                <span class="ffs-box__dot ffs-box__dot--${group.id}"${this.flyDotStyle(group.id)} aria-hidden="true"></span>
                ${group.label}
              </h3>
              <div class="ffs-box__grid">${groupFlies.map(flyCard).join('')}</div>
            </section>
          `;
        })
        .join('');

      const summaryLabel =
        count > 0
          ? `${count} ${count === 1 ? 'fly' : 'flies'}`
          : 'No flies selected';

      const regionMeta = this.regionMeta(this.boxRegion);
      const elevMeta = this.elevationMeta(this.boxElevation);
      const waterMeta = this.waterTypeMeta(this.boxWaterType);
      const regionPick = regionMeta.shortLabel || regionMeta.label || this.boxRegion;
      const elevPick = elevMeta.label || this.boxElevation;
      const waterPick = waterMeta.label || this.boxWaterType;

      el.innerHTML = `
        <div class="ffs-box">
          <div class="ffs-box__filters ffs-report__pickers">
            <div class="ffs-report__picker ffs-box__picker">
              <label class="ffs-box__filter-label" for="ffs-box-region">Fishing region</label>
              <select class="ffs-report__select" id="ffs-box-region" data-ffs-box-region>
                ${regionOptions}
              </select>
            </div>
            <div class="ffs-report__picker ffs-box__picker">
              <label class="ffs-box__filter-label" for="ffs-box-elevation">Elevation</label>
              <select class="ffs-report__select" id="ffs-box-elevation" data-ffs-box-elevation>
                ${elevOptions}
              </select>
            </div>
            <div class="ffs-report__picker ffs-box__picker">
              <label class="ffs-box__filter-label" for="ffs-box-water">Water type</label>
              <select class="ffs-report__select" id="ffs-box-water" data-ffs-box-water>
                ${waterOptions}
              </select>
            </div>
          </div>

          <p class="ffs-box__for" aria-live="polite">
            Flies hand picked for
            <strong class="ffs-box__for-glow">${regionPick}</strong>
            <strong class="ffs-box__for-glow">${elevPick}</strong>
            <strong class="ffs-box__for-glow">${waterPick}</strong>
          </p>

          <div class="ffs-box__groups">${kindGroups}</div>
          <div class="ffs-box__bar">
            <div class="ffs-box__bar-main">
              <button type="button" class="ffs-box__cta" data-ffs-box-add ${count ? '' : 'disabled'}>
                <span class="ffs-box__cta-copy">
                  <span class="ffs-box__cta-label">Add to cart</span>
                  <span class="ffs-box__cta-meta">
                    <span data-ffs-box-count>${summaryLabel}</span>
                    <span aria-hidden="true">·</span>
                    <span data-ffs-box-total>${this.money(total)}</span>
                  </span>
                </span>
              </button>
              <div class="ffs-box__actions">
                <div class="ffs-box__bulk" role="group" aria-label="Set quantity of each fly">
                  <button type="button" class="ffs-box__bulk-btn" data-bulk-delta="-1" aria-label="Decrease of-each quantity">−</button>
                  <input
                    class="ffs-box__bulk-input"
                    type="number"
                    min="1"
                    max="${this.boxMaxQty}"
                    value="${this.boxDefaultQty}"
                    inputmode="numeric"
                    data-ffs-box-bulk-qty
                    aria-label="Quantity of each"
                  >
                  <button type="button" class="ffs-box__bulk-btn" data-bulk-delta="1" aria-label="Increase of-each quantity">+</button>
                  <button type="button" class="ffs-box__bulk-apply" data-ffs-box-apply-bulk>of each</button>
                </div>
                <button type="button" class="ffs-box__ghost" data-ffs-box-clear>Clear</button>
              </div>
            </div>
            <p class="ffs-box__status" data-ffs-box-status hidden></p>
          </div>
        </div>
      `;

      const onFilterChange = (setter) => (event) => {
        setter(event.target.value);
        this.resetBoxSelection();
        this.showBoxLoadingThenRender();
      };

      el.querySelector('[data-ffs-box-region]')?.addEventListener(
        'change',
        onFilterChange((v) => {
          this.boxRegion = v;
          this.syncHatchToBox();
        })
      );
      el.querySelector('[data-ffs-box-elevation]')?.addEventListener(
        'change',
        onFilterChange((v) => {
          this.boxElevation = v;
        })
      );
      el.querySelector('[data-ffs-box-water]')?.addEventListener(
        'change',
        onFilterChange((v) => {
          this.boxWaterType = v;
        })
      );

      el.querySelectorAll('[data-qty-delta]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const handle = btn.dataset.flyHandle;
          const delta = Number(btn.dataset.qtyDelta) || 0;
          this.setFlyQty(handle, this.flyQty(handle) + delta);
          this.renderBestFlies();
        });
      });

      const bulkInput = el.querySelector('[data-ffs-box-bulk-qty]');
      const readBulkQty = () => this.clampBulkQty(bulkInput?.value || this.boxDefaultQty);

      el.querySelectorAll('[data-bulk-delta]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const next = this.clampBulkQty(readBulkQty() + (Number(btn.dataset.bulkDelta) || 0));
          if (bulkInput) bulkInput.value = String(next);
          this.applyBulkQty(next);
          this.renderBestFlies();
        });
      });

      el.querySelector('[data-ffs-box-apply-bulk]')?.addEventListener('click', () => {
        this.applyBulkQty(readBulkQty());
        this.renderBestFlies();
      });

      bulkInput?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.applyBulkQty(readBulkQty());
        this.renderBestFlies();
      });

      bulkInput?.addEventListener('change', () => {
        const next = readBulkQty();
        bulkInput.value = String(next);
        this.boxDefaultQty = next;
      });

      el.querySelector('[data-ffs-box-clear]')?.addEventListener('click', () => {
        this.clearBoxSelection();
        this.renderBestFlies();
      });

      el.querySelector('[data-ffs-box-add]')?.addEventListener('click', () => this.addBoxToCart());
    }

    showBoxLoadingThenRender() {
      const el = this.$('[data-ffs-report-best-flies]');
      if (!el) {
        this.renderBestFlies();
        return;
      }

      const groups = el.querySelector('.ffs-box__groups');
      const bar = el.querySelector('.ffs-box__bar');
      if (groups) {
        groups.innerHTML = `
          <div class="ffs-box__loading" role="status" aria-live="polite">
            <span class="ffs-box__loading-spinner" aria-hidden="true"></span>
            <p class="ffs-box__loading-text">Selecting the best current flies for your waters</p>
          </div>
        `;
      }
      if (bar) bar.hidden = true;

      /* Disable filters while loading so rapid changes don't stack */
      el.querySelectorAll('[data-ffs-box-region], [data-ffs-box-elevation], [data-ffs-box-water]').forEach((sel) => {
        sel.disabled = true;
      });

      clearTimeout(this._boxLoadTimer);
      this._boxLoadTimer = setTimeout(() => {
        this.renderBestFlies();
      }, 1100);
    }

    async addBoxToCart() {
      const selected = this.selectedFlyList();
      const status = this.$('[data-ffs-box-status]');
      const cta = this.$('[data-ffs-box-add]');
      if (!selected.length) return;

      const regionName = this.regionLabel(this.boxRegion);
      const elev = this.elevationMeta(this.boxElevation);
      const water = this.waterTypeMeta(this.boxWaterType);
      const { count } = this.boxTotals();
      const boxLabel = `${count} flies · ${regionName} · ${elev.label} · ${water.label}`;

      if (cta) {
        cta.disabled = true;
        const label = cta.querySelector('.ffs-box__cta-label');
        if (label) label.textContent = 'Adding…';
      }
      if (status) {
        status.hidden = false;
        status.textContent = '';
        status.classList.remove('is-error');
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: selected.map((f) => ({
              id: f.variantId,
              quantity: f.qty,
              properties: { _ffs_custom_box: boxLabel },
            })),
          }),
        });
        if (!res.ok) throw new Error('Cart add failed');
        if (status) status.textContent = `${count} flies added — opening cart…`;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      } catch (e) {
        if (status) {
          status.classList.add('is-error');
          status.textContent = 'Couldn’t add the box. Try again or shop the flies individually.';
        }
        if (cta) {
          cta.disabled = false;
          const label = cta.querySelector('.ffs-box__cta-label');
          if (label) label.textContent = 'Add to cart';
        }
      }
    }

    renderSources() {
      const el = this.$('[data-ffs-report-sources]');
      if (!el) return;
      el.innerHTML = DATA.sources
        .map(
          (s) =>
            `<a class="ffs-report__source-chip" href="${s.url}" target="_blank" rel="noopener noreferrer"><strong>${s.name}</strong><span>${s.desc}</span></a>`
        )
        .join('');
    }

    async fetchGauges() {
      const ids = [...new Set(DATA.rivers.map((r) => r.siteId))].join(',');
      try {
        const res = await fetch(`${USGS_IV}&sites=${ids}`);
        if (!res.ok) throw new Error('USGS unavailable');
        const json = await res.json();
        const series = json?.value?.timeSeries || [];
        series.forEach((ts) => {
          const siteId = ts.sourceInfo?.siteCode?.[0]?.value;
          const param = ts.variable?.variableCode?.[0]?.value;
          const val = ts.values?.[0]?.value?.slice(-1)?.[0]?.value;
          if (!siteId || val == null) return;
          if (!this.gaugeData[siteId]) this.gaugeData[siteId] = {};
          if (param === '00060') this.gaugeData[siteId].flow = val;
          if (param === '00010') this.gaugeData[siteId].temp = val;
        });
        this.renderRivers();
        this.updateTimestamp(true);
      } catch (e) {
        this.$('[data-ffs-report-status]')?.classList.add('is-error');
        this.$('[data-ffs-report-status-text]') &&
          (this.$('[data-ffs-report-status-text]').textContent =
            'Live gauge data temporarily unavailable — hatch intel below is still current.');
        this.renderRivers();
      }
    }

    updateTimestamp(live) {
      const el = this.$('[data-ffs-report-updated]');
      if (!el) return;
      const now = new Date();
      const opts = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' };
      el.textContent = live
        ? `Live USGS data · Updated ${now.toLocaleString(undefined, opts)}`
        : `Loading live conditions…`;
    }
  }

  if (!customElements.get('ffs-fishing-report')) {
    customElements.define('ffs-fishing-report', FfsFishingReport);
  }
})();
